import React, { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { Col, Form, Input, Select, DatePicker, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import VehicleStore from "../../../store/VehicleStore";

const { Option } = Select;

const VehicleInfoAwtlProFormFields = (props) => {
  const shouldShow = shouldShowComponent(
    config.project,
    "VehicleInfoAwtlProFormFields",
  );

  const storeContext = useContext(StoreContext);
  const vehicleStore = new VehicleStore();

  if (!shouldShow) {
    return null;
  }
  return (
    <>
      <Col span={12} className="formColumnClass">
        {(props.isadmin.isadmin == -1 || props.isadmin.isadmin == 3) && (
          <Form.Item
            name="invoiceNo"
            label={
              <span>
                {storeContext.translate("_INVOICE_NUMBER_")}
                <span style={{ color: "red" }}>*</span>
              </span>
            }
            required={false}
            rules={[
              {
                required: true,
                message: `${storeContext.translate(
                  "_INVOICE_NUMBER_",
                )} ${storeContext.translate("_IS_REQUIRED_")}`,
              },
            ]}
            help={props.invoiceError || null}
            validateStatus={props.invoiceError ? "error" : ""}

          >
          

            <Input />
          </Form.Item>
        )}

        <Form.Item
          name="renewablePrice"
          label={storeContext.translate("_RENEWABLE_PRICE_")}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="baseLocation"
          label={storeContext.translate("_BASE_LOCATION_")}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="fuelCapacity"
          label={storeContext.translate("_FUEL_CAPACITY_")}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="noOfFuelTank"
          label={storeContext.translate("_NO_OF_FUEL_TANK_")}
        >
          <Select
            options={[
              { label: "1", value: 1 },
              { label: "2", value: 2 },
              { label: "3", value: 3 },
              { label: "4", value: 4 },
            ]}
          />
        </Form.Item>

        <Form.Item name="region" label={storeContext.translate("_REGION_")}>
          <Input />
        </Form.Item>
        <Form.Item
          name="lastBatteryChange"
          label={storeContext.translate("_LAST_BATTERY_CHANGE_")}
        >
          <DatePicker
            style={{ width: "100%", height: "40px" }}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      </Col>
      <Col span={12} className="formColumnClass">
        <Form.Item
          name="stationName"
          label={storeContext.translate("_STATION_")}
        >
          <Select
            className="custom-select-height"
            showSearch
            mode="tags"
            maxCount={1}
            options={
              props.stationlist?.length
                ? props.stationlist.map((val) => ({
                    value: val.id, // store name if typed
                    label: val.station,
                  }))
                : []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="supervisorName"
          label={storeContext.translate("_SUPERVISOR_NAME_")}
        >
          <Select
            className="custom-select-height"
            showSearch
            mode="tags"
            // placeholder="Enter supervisor name"
            options={
              props.supervisorlist?.length
                ? props.supervisorlist.map((val) => ({
                    value: val.id, // store name if typed
                    label: val.name,
                  }))
                : []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item>
        <Form.Item
          name="customerName"
          label={storeContext.translate("_CUSTOMER_NAME_")}
        >
          <Select
            className="custom-select-height"
            showSearch
            mode="tags"
            options={
              props.customerlist?.map((val) => ({
                value: val.id,
                label: val.name,
              })) || []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="assetTypeCustomName"
          label={storeContext.translate("_ASSET_TYPE_")}
        >
          <Select
            mode="combobox"
            // placeholder="Enter supervisor name"
            options={
              props.assettypelist?.length
                ? props.assettypelist.map((val) => ({
                    value: val.id, // store name if typed
                    label: val.name,
                  }))
                : []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item>
        {/* {console.log(props.devicelist, "props.devicebrandlist")} */}
        <Form.Item
          name="deviceBrandName"
          label={storeContext.translate("_DEVICE_BRAND_")}
        >
          <Select
            mode="combobox"
            // placeholder="Enter supervisor name"
            options={
              props.devicelist?.length
                ? props.devicelist.map((val) => ({
                    value: val.id, // store name if typed
                    label: val.name,
                  }))
                : []
            }
            onChange={(value, option) => {
              if (value.length > 1) {
                value.splice(0, value.length - 1); // keep only latest
              }
            }}
          />
        </Form.Item>
        <Form.Item name="branch" label={storeContext.translate("_BRANCH_")}>
          <Input />
        </Form.Item>

        <Form.Item
          name="department"
          label={storeContext.translate("_DEPARTMENT_")}
        >
          <Input />
        </Form.Item>

        {/* <Form.Item
          name="ownership"
          label={storeContext.translate("_OWNERSHIP_")}
        >
          <Select
            options={[
              { label: "Own", value: "Own" },
              { label: "Rented", value: "Rented" },
            ]}
          />
        </Form.Item> */}

        {/*  */}
      </Col>
    </>
  );
};

export default observer(withRouter(VehicleInfoAwtlProFormFields));
